import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface SectionHeadingProps {
    id?: string
    eyebrow?: string
    title: ReactNode
    description?: ReactNode
    action?: ReactNode
    as?: 'h1' | 'h2'
    className?: string
}

export const SectionHeading: FC<SectionHeadingProps> = ({
    id,
    eyebrow,
    title,
    description,
    action,
    as: Heading = 'h2',
    className
}): ReactNode => {
    return (
        <div className={cn('flex flex-wrap items-end justify-between gap-x-6 gap-y-4', className)}>
            <div className='max-w-2xl'>
                {eyebrow && (
                    <p className='text-xs font-semibold tracking-[0.16em] text-brand uppercase'>
                        {eyebrow}
                    </p>
                )}

                <Heading
                    id={id}
                    className={cn(
                        'font-heading leading-[1.05] tracking-tight text-foreground',
                        Heading === 'h1' ? 'mt-3 text-5xl sm:text-6xl' : 'mt-2 text-3xl sm:text-4xl'
                    )}
                >
                    {title}
                </Heading>

                {description && (
                    <div className='mt-3 text-[0.95rem] leading-relaxed text-muted-foreground'>
                        {description}
                    </div>
                )}
            </div>

            {action}
        </div>
    )
}
